import React from 'react'

import { Tooltip } from 'src/components/atoms'
import { FormItemTitle } from 'src/components/molecules'

type Props = {
  title: string | React.ReactNode
  showRequired?: boolean
  tooltipContent?: React.ReactNode
  children: React.ReactNode
  className?: string
}

export function FormItemVertical({
  title,
  showRequired,
  tooltipContent,
  children,
  className,
}: Props) {
  return (
    <div className={className}>
      <div className="tw-flex tw-flex-col tw-gap-s-4">
        <div className="tw-flex tw-items-center">
          <div>
            {tooltipContent ? (
              <Tooltip content={tooltipContent} placement="top">
                <FormItemTitle text={title} showRequired={showRequired} />
              </Tooltip>
            ) : (
              <FormItemTitle text={title} showRequired={showRequired} />
            )}
          </div>
        </div>
        <div>{children}</div>
      </div>
    </div>
  )
}
